var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-volume h-100 w-100",style:({
    background: 'linear-gradient(' + _vm.angle + 'deg, ' + _vm.barColor + _vm.gradient + '%, transparent 0%) !important'
  })},[_c('span',{staticClass:"volume-value"},[_c('v-fidlet',{attrs:{"data":_vm.value || '',"type":"int"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }